<template>
    <div class="tabs_content" v-if="!loading">
      <section>
        <div class="status"><h2 v-translate>Spárovaná zařízení</h2>
          <h2>&nbsp;({{ biller.devices.length }})</h2></div>

        <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="billers-devices">
            <table class="vypis">
              <thead>
              <tr v-if="biller.devices && biller.devices.length > 0">
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in sortingTableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    :extra-style="title.style"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding"></th>
              </tr>
              </thead>
              <tr v-for="entity in entities" :key="entity.id" @click.stop="showDeviceDetail(entity.id)"
                  :class="{'clickable': $_loggedUser_action_allowed('devices')}">
                <td class="no_padding drag_drop"><span></span></td>
                <td class="no_padding">
                  <input type="checkbox"
                         :id="entity.id"
                         :value="entity.id"
                         v-model="selectedEntities"
                         @click.stop
                  />
                  <label :for="entity.id" @click.stop v-translate>Vybrat</label>
                </td>
                <td data-th="ID zařízení">{{ entity.id }}</td>
                <td data-th="Jméno zařízení"><strong>{{ entity.name }}</strong></td>
                <td data-th="Model">{{ entity.model }}</td>
                <td data-th="S/N">{{ entity.serial_number }}</td>
                <td data-th="Jméno odběratele">
                  <entity-link :id="entity.id_subscriber" type="subscriber">{{ entity.name_subscriber }}</entity-link>
                </td>
                <td data-th="Spárováno" v-html="$_date_formatFull(entity.timestamp_paired)"></td>
                <td data-th="Vytvořeno" v-html="$_date_formatFull(entity.timestamp_created)"></td>
                <td class="no_padding"></td>
              </tr>
              <tr v-if="!biller.devices || biller.devices.length === 0">
                <td colspan="8">{{ $gettext("Odběratelé plátce nemají spárována žádná zařízení.") }}</td>
              </tr>
            </table>
          </div>
        </div>
        <local-list-action-line
            :entities="entities"
            :selected-entities="selectedEntities"
            :multiple-action-options="multipleActionOptions"
            table-id="billers-devices"
            @select-all="toggleSelectAll"
            @run-multiple-action="runMultipleAction"
        ></local-list-action-line>
      </section>
    </div>
</template>

<script>
import SortingTableTitle from "../../../common/SortingTableTitle";
import localTable from "@/components/mixins/local-table"
import EntityLink from "../../../common/EntityLink.vue";
import links from "../../../mixins/links";

export default {
  name: "DeviceList",
  components: { EntityLink, SortingTableTitle},
  props: ["biller", "loading"],
  mixins: [localTable, links],
  data() {
    return {
      moduleName: "billerDeviceList",
    }
  },
  computed: {
    sortingTableTitles() {
      return [
        {id: 1, name: this.$gettext('ID zařízení'), column: 'id', style: {minWidth: '110px'}},
        {id: 2, name: this.$gettext('Jméno zařízení'), column: 'name'},
        {id: 3, name: this.$gettext('Model'), column: 'model'},
        {id: 4, name: this.$gettext('S/N'), column: 'serial_number'},
        {id: 5, name: this.$gettext('Jméno odběratele'), column: 'name_subscriber'},
        {id: 6, name: this.$gettext('Spárováno'), column: 'timestamp_paired'},
        {id: 7, name: this.$gettext('Vytvořeno'), column: 'timestamp_created'}
      ]
    },
    entities() {
      return this.biller.devices.sort(this.getSortingFunction());
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      headers.timestamp_paired.callback = (entity) => {return entity.timestamp_paired ? this.$_datetime_format(entity.timestamp_paired) : ''; };
      headers.timestamp_created.callback = (entity) => {return entity.timestamp_created ? this.$_datetime_format(entity.timestamp_created) : ''; };

      return headers;
    },
  },
  methods: {
    getDefaultSorting() {
      return {column: 'id', direction: 'asc'};
    },
    getSortingFunction() {
      return (deviceA, deviceB) => {
        let sortResult = 0;

        switch (this.sort.column) {
          case 'name':
          case 'model':
          case 'serial_number':
          case 'name_subscriber':
            sortResult = this.stringCompare(deviceA[this.sort.column], deviceB[this.sort.column]);
            break;
          case 'id':
          case 'timestamp_paired':
          case 'timestamp_created':
            sortResult = this.integerCompare(deviceA[this.sort.column], deviceB[this.sort.column]);
            break;
        }

        return this.sort.direction === "asc" ? sortResult : (-1) * sortResult;
      }
    }
  },
}

</script>



// WEBPACK FOOTER //
// src/components/views/billers/billerDetail/DeviceList.vue